import * as React from 'react'
import type { SVGProps } from 'react'
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 11" {...props}>
    <path fill="#333" fillRule="evenodd" d="m18.854 11 1.12-1.16-9.5-9.84-9.5 9.84L2.093 11l8.38-8.68z" clipRule="evenodd" />
  </svg>
)
export default SvgChevronUp
